import $ from 'jquery';
import _ from 'underscore';
import PubSub from 'pubsub-js';
import ScrollMagic from 'scrollmagic';
import 'scrollmagic-gsap';
import 'scrollmagic-indicators';
var App = function() {

	var scrollMagicController;

	// Listners / PubSub
	$(window).on('resize', _.debounce(onWindowResize, 250));

	// Scroll Magic
	scrollMagicController = new ScrollMagic.Controller();

	function getScrollMagicController() {
		return scrollMagicController;
	}

	function onWindowResize() {
		triggerRenderLayout();
	}

	function triggerRenderLayout() {
		PubSub.publish('updatelayout');
	}

	return {
		getScrollMagicController: getScrollMagicController
	}
}

export default App();